module.exports = __webpack_public_path__ + "9d5d7cd501efae924df39659fbb5fca7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/public/img/washs/wash-4.jpg
// module id = 78
// module chunks = 0